import axios from '@/axios/globalaxios'

export const viewSchoolCourses = data =>{
    return axios({
        url: "/tradelab/financial/viewSchoolCourses",
        method: 'post',
        data:data
    })
}

export const pullUsersByCourseIdAndCompetitionId = data =>{
    return axios({
        url: "/tradelab/financial/pullUsersByCourseIdAndCompetitionId",
        method: 'post',
        data:data
    })
}
